module.exports = __webpack_public_path__ + "static/media/zoom.02cb4078.svg";